import sha from 'sha.js';

const algorithmHash = 'sha256';
const outputEncoding = 'hex';
const separator = ':_';

/**
 * This nodejs hashing algorithm will produce the same hash as
 * this one in mysql 5.7:
 *
 * select SHA2(text, 256)
 *
 * This is a legacy wire-format transformation, not a password-storage KDF.
 * Storage must be hardened server-side with a per-user salt and adaptive KDF;
 * changing this output independently would break login, update, and verifyUser.
 *
 * @param password - the text to produce a hash from
 * @param username - the username
 * @returns {string} the legacy SHA-256 wire credential
 */
// eslint-disable-next-line import/prefer-default-export
export const hashPassword = (password, username) => {
  // Type validation to prevent cipher-base/sha.js type confusion exploits
  if (typeof password !== 'string' || typeof username !== 'string') {
    throw new TypeError('Password and username must be strings');
  }

  return sha(algorithmHash)
    .update(username.toLowerCase() + separator + password)
    .digest(outputEncoding);
};
